module.exports = __webpack_public_path__ + "resources/img/img_speech_to_text2_en_m.476f695f8646fdda1415dfec428dfc04.png";